define 'controller/ProductController', ['jquery', 'custom/controller', 'lib/photoswipe', 'lib/photoswipe-ui-default', 'custom/media-query', 'lib/slick', 'lib/kryptonite'], ($, controller, PhotoSwipe, PhotoSwipeUI_Default, mq) ->
  class ProductController

    constructor: (@$el) ->
      @_init()
      @_changeColorSelectionButtonTextOnResize()

    _init: ->
      $('.main-pictures__carousel').not('.slick-initialized').slick({
        draggable: true,
        infinite: true,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Image précédente" data-test-product-slick-prev></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Image suivante" data-test-product-slick-next></button>',
      })

      $('.main-thumbs').not('.slick-initialized').slick({
        vertical: true,
        draggable: false,
        infinite: true,
        slidesToShow: 3,
        focusOnSelect: true,
        asNavFor: '.main-pictures__carousel',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Image précédente" data-test-product-slick-prev></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Image suivante" data-test-product-slick-next></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              vertical: false,
              draggable: true,
              slidesToShow: 3
            }
          }
        ]
      })
      $('#customer-reviews').on "reviews-loaded", @_showReviewsIfThereAreNoReviews

      @_addToBasket()
      @_changeColorSelectionButtonText()
      @_colorSelect()
      @_initPhotoSwipe()
      @_loadCustomerReviewsScript()
      @_modelSelect()
      @_setFeaturesVisibility()
      @_toggleFeatures()
      @_toggleOnResize()
      @_toggleReviews()
      @_variationSelect()
      @_atbStickyButton()
      @_toggleATBStickyButton()

    _atbStickyButton: ->
      self = @
      $atbButtonContainer = @$el.find('[data-controller-element=atb-button-container]')
      $stickyButtonWrapper = @$el.find('[data-controller-element=atb-sticky-button-wrapper]')
      $(window).on 'scroll resize', ->
        buttonWrapperHeight = $stickyButtonWrapper.outerHeight()
        self._toggleATBStickyButton($atbButtonContainer, $stickyButtonWrapper, buttonWrapperHeight)

    _toggleATBStickyButton: ($bContainer, $sbWrapper, bwHeight) ->
      if !$bContainer
        $bContainer = @$el.find('[data-controller-element=atb-button-container]')
      if !$sbWrapper
        $sbWrapper = @$el.find('[data-controller-element=atb-sticky-button-wrapper]')
        bwHeight = $sbWrapper.outerHeight()

      if mq.up_to_M
        buttonContainerRect = $bContainer[0].getBoundingClientRect()

        if bwHeight-buttonContainerRect.height>0 && buttonContainerRect.bottom <= $(window).height()
          bwHeight = buttonContainerRect.height

        if buttonContainerRect.top+bwHeight >=0 && buttonContainerRect.bottom <= $(window).height()
          @_resetATBButton($bContainer, $sbWrapper)
        else
          if !$sbWrapper.hasClass('fixed')
            $bContainer.css('min-height', bwHeight+'px')
            $sbWrapper.addClass('fixed')
            $('body').css('padding-bottom',$bContainer.outerHeight()+'px')
            $sbWrapper.find('[data-controller-element=atb-main-button]').attr('type', 'button')
      else
        @_resetATBButton($bContainer, $sbWrapper)

    _resetATBButton: ($bContainer, $sbWrapper) ->
      if $sbWrapper.hasClass('fixed')
        $bContainer.css('min-height', '')
        $sbWrapper.removeClass('fixed')
        $sbWrapper.find('[data-controller-element=atb-main-button]').attr('type', 'submit')
        $('body').css('padding-bottom', '')

    _changeColorSelectionButtonTextOnResize: ->
      self = @
      $(document).ready ->
        $(window).resize ->
          self._changeColorSelectionButtonText()

    _changeColorSelectionButtonText: () ->
      self = this

      if window.innerWidth < 910
        numberOfShownElements = 6
      else if window.innerWidth < 1199
        numberOfShownElements = 7
      else
        numberOfShownElements = 9

      $colors = $(".color-selection__color")

      if $colors.length <= numberOfShownElements
        $colors.addClass("color-selection__show")
        return

      @_showOnlyNumberOfColors(numberOfShownElements)

      numberOfHiddenElements = $colors.length - numberOfShownElements
      showText = "+ " + numberOfHiddenElements + " couleurs"
      hideText = "- de couleurs"

      colorSelectionButton = $("#js-color-selection__showMore")
      colorSelectionButton.text(showText)
      colorSelectionButton.addClass "color-selection__show"
      colorSelectionButton.off "click"
      colorSelectionButton.on "click", ->
        showMore = colorSelectionButton.text() == showText

        if (showMore)
          colorSelectionButton.text(hideText)
          $colors.addClass("color-selection__show")
        else
          colorSelectionButton.text(showText)
          self._showOnlyNumberOfColors(numberOfShownElements)


    _showOnlyNumberOfColors: (numberOfShownElements) ->
      $colors = $('.color-selection__color')
      isSelectedColorVisible = false

      $colors.removeClass('color-selection__show')

      for i in [0..numberOfShownElements-2]
        $color = $($colors[i])
        $color.addClass('color-selection__show')

        if $color.hasClass('selected')
          isSelectedColorVisible = true

      $lastColor = if isSelectedColorVisible then $($colors[numberOfShownElements - 1]) else $colors.filter('.selected')
      $lastColor.addClass('color-selection__show')

    _initPhotoSwipe: ->
      $zoomButton = @$el.find('[data-controller-element=main-picture-zoom-button]')

      openPhotoSwipe = (e) ->
        pswpElement = document.querySelectorAll('.pswp')[0]
        # build items array
        items = $('.pswp').data('items')

        # index of the active image
        pswpIndex = 0
        $el = $(e.currentTarget)
        $mainPicturesWrappers = $el.closest("[data-controller-element=main-pictures-wrapper]")
        if $el.attr("src")?
          imgSrc = $el.attr("src")
        else if $mainPicturesWrappers.length > 0
          imgSrc = $mainPicturesWrappers.find(".slick-active img").attr("src")

        if imgSrc?
          pswpIndex = items.findIndex (item) ->
            item.src.split("/p/")[1] == imgSrc.split("/p/")[1]
          #console.log("pswpIndex", pswpIndex)

        options = {
          index: if (pswpIndex == -1) then 0 else pswpIndex,
          captionEl: false,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: false,
          tapToToggleControls: false,
          closeOnScroll: false
        }

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)

        gallery.listen 'beforeChange', ->
          $('body').addClass("pswp-active")
          $zoomButton.attr("aria-expanded", true)
        gallery.listen 'close', ->
          $('body').removeClass("pswp-active")
          $zoomButton.attr("aria-expanded", false)

        gallery.init()
        return

      $("[data-controller-element=main-picture-zoom-button], [data-controller-element=product-main-images] [data-controller-element=product-image]").off()
      $("[data-controller-element=main-picture-zoom-button], [data-controller-element=product-main-images] [data-controller-element=product-image]").on 'click',(e) ->
        openPhotoSwipe(e)

    changeToNewUrl = (externalKey, oldKey) ->
      ref = externalKey.toString().substring(0, 6)
      media = externalKey.toString().substring(6, 9)
      if(externalKey.toString().length > 10)
        size = externalKey.toString().substring(10)
        while (size.length < 3)
          size = '0' + size
      else if(oldKey != undefined && oldKey.toString().length > 10)
        size = oldKey.toString().substring(10)
        while (size.length < 3)
          size = '0' + size

      newurl = window.location.href + ''
      newurl = newurl.split('?')[0]
      newurl = newurl.concat('?article=' + ref)
      if(size != undefined)
        newurl = newurl.concat('&size=' + size)
        size = size.replace('^0*', '')
      newurl = newurl.concat('&media=' + media)

      categoryHint = new URL(window.location.href).searchParams.get('cat')
      if categoryHint != null
        newurl = newurl.concat('&cat='+categoryHint)
      history.replaceState({ref: ref + media, size: size}, window.title, newurl)

    refreshMainThumbsSlider = ->
      if $('.main-thumbs__thumb').length > 0
        setTimeout (->
          $('.main-thumbs').slick 'refresh'
          return
        ), 250

    _modelSelect: ->
      self = @
      $('.js_modelSelection').off()
      $('.js_modelSelection').on 'click', 'li', (e) ->
        $el = $(@)
        url = $el.data 'url'
        model = $el.data 'value'
        # color = $('.js_productSelection li.selected').data('value') || $('.js_promoitem_input').val()
        color = $('.js_productSelection li.selected').data('text')
        $variationInput = $('.js_variation_input')
        variation = $('.js_variationSelection li.selected').data('value') || $variationInput.val()
        url = "/p/#{model}/#{url}?color=#{color}&variation=#{variation}"
        categoryHint = new URL(window.location.href).searchParams.get('cat')
        if categoryHint != null
          url = url.concat('&cat='+categoryHint)

        if $el.closest('#stickyModelModalContentList').length > 0
          isProcessing = true

        $.kryptonite
          url: url
          xhrFields:
            keepShowingLoadingIndicator: if isProcessing then isProcessing else false
          success: ->
            color = $('.js_productSelection li.selected').data('value') || $('.js_promoitem_input').val()
            variation = $('.js_variationSelection li.selected').data('value') || $variationInput.val()
            changeToNewUrl(color, variation)
            self.$el.data('model-selected', 'true')
            #history.pushState({ref: ref+media, size: size},window.title,newurl)
          complete: ->
            self._init()
            if $el.closest('#stickyModelModalContentList').length > 0
              $('#modalOverlayRight').modal('hide').on 'hidden.bs.modal', () ->
                $sizeOpenEl = $('[data-controller-element=size-open-button]')
                if ($variationInput.val() && $variationInput.data('is-soldout')) || !$variationInput.val() && $sizeOpenEl.length > 0
                  setTimeout(
                    ->
                      $sizeOpenEl.click()
                  , 300
                  )
                else
                  $('#addToBasketForm').submit()

    _colorSelect: ->
      self = @
      $('.js_productSelection').off()
      $('.js_productSelection').on 'click', 'li', (e) ->
        $el = $(@)
        url = $el.data 'url'
        color = $el.data 'value'
        variation = $('.js_variationSelection li.selected').data('value') || $('.js_variation_input').val()
        url = "/p/#{color}/#{url}?variation=#{variation}"
        categoryHint = new URL(window.location.href).searchParams.get('cat')
        if categoryHint != null
          url = url.concat('&cat='+categoryHint)
        $.kryptonite
          url: url
          success: ->
            changeToNewUrl(color, variation)
            refreshMainThumbsSlider()
          complete: ->
            self._init()

    _variationSelect: ->
      self = @
      $('.js_variationSelection').off()
      $('.js_variationSelection').on 'click', 'li:not(.disabled)', (e) ->
        $el = $(@)
        $('.product__price__value').html $(@).data('price')
        $('.product__selection__error-message').addClass('hidden')
        $('.js_variation_input').parent().removeClass('custom-dropdown__error')
        url = $el.data 'url'
        variationKey = $el.data 'value'
        url = "/p/#{url}#{variationKey}"
        categoryHint = new URL(window.location.href).searchParams.get('cat')
        if categoryHint != null
          url = url.concat('?cat='+categoryHint)

        # close the rightpanel if the selection was in the layer
        if $el.closest('#stickySizeModalContentList').length > 0
          $('#modalOverlayRight').modal('hide')

        $.kryptonite
          url: url
          success: ->
            changeToNewUrl(variationKey, undefined)
            refreshMainThumbsSlider()
            if $el.closest('#stickySizeModalContentList').length > 0
              $("#loading-overlay").addClass("processing")
          complete: ->
            self._init()
            if $el.closest('#stickySizeModalContentList').length > 0
              $('#addToBasketForm').submit()

    _addToBasket: ->
      self = @
      $('#addToBasketForm').off()
      @$el.find('[data-controller-element=atb-main-button]').on 'click', (e) ->
        $button = $(e.currentTarget)
        $modelOpenEl = self.$el.find('[data-controller-element=model-open-button]')
        $sizeOpenEl = self.$el.find('[data-controller-element=size-open-button]')
        $variationInput = $('.js_variation_input')
        if $button.attr('type') != "submit"
          if $modelOpenEl.length > 0 && !self.$el.data('model-selected')
            $modelOpenEl.click()
          else if ($variationInput.val() && $variationInput.data('is-soldout')) || !$variationInput.val() && $sizeOpenEl.length > 0
            $sizeOpenEl.click()
          else
            $('#addToBasketForm').submit()

      $('#addToBasketForm').on 'submit', (e) ->
        e.preventDefault()
        if (!$('.js_variation_input').val())
          $('.product__selection__error-message').removeClass('hidden')
          $('.js_variation_input').parent().addClass('custom-dropdown__error')
          return false

        $form = $(@)
        $.kryptonite
          url: $form.attr('data-url')
          type: $form.attr('method')
          data: $form.serialize()
          complete: ->
            $('body #loading-overlay').remove()

            if typeof getDataLayerAdd == typeof Function
              dataLayer.push(getDataLayerAdd())
            self._initializeSlickImagesAfterLayerShown()

    _initializeSlickImagesAfterLayerShown: ->
      $('#modalOverlay').on 'shown.bs.modal', (e) ->
        $('.product__carousel').resize()

    _selectCustomDropdown: ->
      $('.custom-dropdown').off()
      $('.custom-dropdown').on 'click', '.js-dropdown-opener', (e) ->
        e.preventDefault()
        $('.custom-dropdown .js-dropdown-opener').not(this).removeClass('active')
        $('.custom-dropdown .js-dropdown-opener').not(this).parent().find('ul').slideUp()
        $(@).toggleClass('active')
        $(@).parent().find('ul').slideToggle()

      $('.custom-dropdown').on 'click', 'li', (e) ->
        $('.custom-dropdown li').removeClass('selected')
        $(@).addClass('selected')
        value = $(@).data('value')
        text = $(@).data('text')
        color = $(@).find('.color-tile img').attr('src')
        $(@).parent('ul').slideUp()
        $(@).closest('.custom-dropdown').find('.js-dropdown-opener').removeClass('active')
        $(@).closest('.custom-dropdown').find('input').val(value)
        $(@).closest('.custom-dropdown').find('.js-dropdown-opener .content').html(text)
        $(@).closest('.custom-dropdown').find('.js-dropdown-opener .content-color img').attr('src', color)

    _setFeaturesVisibility: ->
      if $('.product').attr('data-accordion-features') == "1"
        $('*[data-accordion="features"]').addClass('active')
        $('*[data-accordion="features"]').parent().next().show()

      if $('.product').attr('data-accordion-description') == "1"
        $('*[data-accordion="description"]').addClass('active')
        $('*[data-accordion="description"]').parent().next().show()

    _toggleFeatures: ->
      $('.product__description-features h2').unbind('click').click ->
        $(this).next().slideToggle()
        $(this).toggleClass('active')
        accordion = $(this).data('accordion')
        if $(this).hasClass('active')
          $('.product').attr('data-accordion-' + accordion, "1")
        else
          $('.product').attr('data-accordion-' + accordion, '')


    #   no longer in use as the ratings are always visible from now on.
    #   Kept it in case, It will be needed again. (renamed product__customer-reviews__inner to product__customer-reviews__element and removed headline in ticket shop-843)
    _toggleReviews: ->
      $('.product__customer-reviews__headline h2').unbind('click').click ->
        $('.product__customer-reviews__inner').slideToggle()
        $(this).toggleClass('active')

    _toggleOnResize: ->
      element = $('.product__customer-reviews__inner')
      if element
        window.onresize = ->
          if window.innerWidth > 767
            $('.product__description-features__inner').addClass('product__description-features__inner--show')
          else
            $('.product__description-features__inner').removeClass('product__description-features__inner--show')
          if element.css("display") is "none"
            $('.product__customer-reviews__headline h2').removeClass('active')
          else
            $('.product__customer-reviews__headline h2').addClass('active')

    _loadCustomerReviewsScript: ->

      if (window.matchMedia('(min-width: 767px)').matches)
        $('.product .product__customer-reviews__inner').hide()

      $('.product .product__short-reviews__link > a').click (e) ->
        e.preventDefault()
        scrollTop = $('.product #customer-reviews').offset().top
        $('.product .product__customer-reviews__inner').show()
        if !$('div').hasClass('active')
          $('.product__customer-reviews__headline h2').addClass('active')

        $('html, body').animate { scrollTop: scrollTop }, 'slow'

      loaded = $('#customer-reviews').data('loaded')
      if loaded == false
        url = $('#customer-reviews').data('url')

        $.ajax({
          url: url,
          cache: true,
          dataType: 'script',
          success: =>
            $('#customer-reviews').data('loaded', true)
            return
        })

        $reviews = $('.product__customer-reviews')

        @_observeDOM $reviews[0], () =>
          @_showReviews()

        # Fallback in case the MutationObserver is not supported by the browser
        setTimeout(() =>
          if $('#netreviews_reviews_tab').length
            @_showReviews()
        , 2000)

      else
        shortReviewsClone = $('#customer-reviews-container').find("[data-controller-element=product-short-reviews]").clone()
        $('[data-controller-element=product-summary]').find("[data-controller-element=product-short-reviews]").replaceWith(shortReviewsClone)

    _showReviews: ->
      $('.product__customer-reviews').removeClass("hide")
      $('.product__short-reviews__link').removeClass("hide")

    _observeDOM: (element, callback) ->
      if !element || element.nodeType != 1
        return

      MutationObserver = window.MutationObserver || window.WebKitMutationObserver

      if !MutationObserver
        return

      new MutationObserver(callback).observe(element, { childList:true, subtree:true })

    destroy: ->
      @$el.off()
